import moment from 'moment';
import { filter } from 'lodash-es';

export function countJobsRaisedToday(openWorkRequests) {
  const jobsRaisedToday = filter(openWorkRequests, (request) => {
    return moment(request.raisedDate).isSame(new Date(), 'days') &&
      request.raisedBy == 'MyKāingaOra';
  });
  let jobsCount = 0;
  jobsRaisedToday.forEach((request) => {
    jobsCount += request.jobs.length;
  })
  return jobsRaisedToday ? jobsCount : 0;
}

export function getWorkRequestAPITypeFromString(string) {
  return string == 'current' ? 'open' : string == 'previous' ? 'completed' : string;
}
